import { apiFetch } from './api';

export interface ApplianceIdentificationData {
  brand?: string;
  assetType?: string;
  modelHint?: string;
  confidence: string;
  qualityIssue?: string;
  qualityTip?: string;
  labelLocations: string[];
  labelSteps: string[];
  identifiedFrom: string;
  wireframe?: {
    deviceShape?: string;
    labelZone?: string;
  };
  wireframeImage?: string;
}

export async function identifyApplianceAndLabel(params: {
  image: string;
  assetTypeHint?: string;
}): Promise<ApplianceIdentificationData> {
  const res = await apiFetch<{ success: boolean; data: ApplianceIdentificationData }>(
    '/v1/ai/identify-appliance-and-label',
    { method: 'POST', body: params },
  );
  return (res as { data: ApplianceIdentificationData }).data;
}
